import React from 'react';
import { Skeleton } from '@unmind/design-system';
import './SkeletonItem.scss';

export const SkeletonItem = () => {
  return (
    <li aria-hidden="true">
      <div className="todo-list-item skeleton-item">
        <span className="thumbnail-rail">
          <Skeleton variant="thumbnail" className="thumbnail" />
        </span>
        <div className="content text-content">
          <Skeleton variant="text" className="heading" />
          <Skeleton variant="text" className="description" />
        </div>
        <Skeleton variant="text" className="action" />
      </div>
    </li>
  );
};
